// extracted by mini-css-extract-plugin
module.exports = {"icon":"SalesforceLeadWidget_icon__-JAil","link":"SalesforceLeadWidget_link__17CRT","noRecord":"SalesforceLeadWidget_noRecord__3-2iR"};